import templateUrl from 'emun.customer/contact-prompt.htm'
import ContactPromptController from 'emun.customer/contact-prompt.controller'
//import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'

const resolve = () => null;
const reject = reason => console.warn('reject reason', reason);

const ContactPrompt = {
    open(options) {
        const prom = modals.open(Object.assign({
            size: 'sm contact-prompt',
            templateUrl,
            resolve: {
                options: () => options
            },
            bindToController: true,
            controller: ContactPromptController,
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;

        prom.then(resolve, reject);

        return prom;
    }
};

export default ContactPrompt;